import React from "react";
import HeroSection from "../components/Hero/HeroSection";
import ClientLogosSlider from "../components/ClientLogoSlider/ClientLogosSlider";
import AboutSection from "../components/About/AboutSection";
import GenAiServices from "../components/Services/GenAiServices";
import TestimonialsDesktop from "../components/Testimonials/TestimonialsDesktop";
import TestimonialsMobile from "../components/Testimonials/TestimonialsMobile";
import SiteFooter from "../components/Layout/Footer/SiteFooter";
import MobileHeader from "../components/Layout/Header/DemoHeader/MobileHeader";
import AppLayout from "../components/Layout/AppLayout";
import DesktopHeader from "../components/Layout/Header/LandingHeader/DesktopHeader";
import TransformationStepsDesktop from "../components/Video/TransformationStepsDesktop";
import TransformationStepsMobile from "../components/Video/TransformationStepsMobile";
import PricingSection from "../components/Price/PricingSection";
import ContactSection from "../components/Contact/ContactSection";
import TechToolkitSection from "../components/Features/TechToolkitSection";
import AIARSuccessStory from "../components/Hero/AIARSuccessStory";
import CelebrationBanner from "../components/Celebration/CelebrationBanner";

export default function LandingOne() {
  return (
    <AppLayout>
      <CelebrationBanner />
      <DesktopHeader />
      <MobileHeader />
      <HeroSection />
      <div id="about">
        <AboutSection />
      </div>
      <GenAiServices />
      <div id="clients">
        <ClientLogosSlider />
      </div>
      <div id="solutions" className="hidden lg:block">
        <TransformationStepsDesktop />
      </div>
      <TransformationStepsMobile />
      <div id="technologies">
        <TechToolkitSection />
      </div>
      <div id="aiar-success-story">
        <AIARSuccessStory />
      </div>
      <div className="hidden lg:block" id="testimonial">
        <TestimonialsDesktop />
      </div>
      <div className="block lg:hidden" id="testimonial-mobile">
        <TestimonialsMobile />
      </div>
      <div id="pricing">
        <PricingSection />
      </div>
      <div id="contact">
        <ContactSection />
      </div>
      <SiteFooter />
    </AppLayout>
  );
}
